
function blockHelper(cookieMgr) {
    $('.block-hdr').on('click', function (e) {
        if ($(this).hasClass('no-toggle')) return;
        // we assume there is only ever one .block-content child
        var elem = $(this).parent('.block').children('.block-content');
        elem.slideToggle(400, function () {
            cookieMgr.setActive(elem);
        });
    });

    this.showActive = function (e) {
        var active = cookieMgr.getActive();
        for (const i in active) {
            $('#' + i).show();
        }
    };
}

module.exports = blockHelper;